import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Wallet } from "@phosphor-icons/react";
import CronogramaBadge from "@/components/CronogramaBadge";

const COP = (n) => new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(n || 0);

export default function MisContratos() {
    const [items, setItems] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        api.get("/mis-contratos-tecnico")
            .then(r => setItems(r.data))
            .catch(e => setError(e.response?.data?.detail || "No se pudo cargar la información"));
    }, []);

    return (
        <div className="max-w-5xl mx-auto p-4 md:p-8" data-testid="mis-contratos-page">
            <div className="overline mb-1" style={{ color: "#0F766E" }}>Mis proyectos</div>
            <h1 className="font-display text-4xl font-black tracking-tighter mb-2">Mis contratos</h1>
            <p className="text-sm text-zinc-600 mb-8">Valor contratado, pagos recibidos y saldo pendiente en cada proyecto donde participas. Solo tú ves esta información.</p>

            {error && <div className="border border-red-300 bg-red-50 p-4 text-sm text-red-700 font-mono">{error}</div>}
            {!items && !error && <div className="text-sm text-zinc-400">Cargando…</div>}
            {items && items.length === 0 && (
                <div className="border border-zinc-200 p-8 text-center text-zinc-400">
                    <Wallet size={32} className="mx-auto mb-2" />
                    Todavía no tienes un valor contratado asignado en ningún proyecto.
                </div>
            )}

            {items && items.length > 0 && (
                <div className="border border-zinc-200 overflow-x-auto">
                    <table className="atia-table">
                        <thead>
                            <tr>
                                <th>Cliente</th>
                                <th>Proyecto</th>
                                <th>Cronograma</th>
                                <th>Contratado</th>
                                <th>Pagado</th>
                                <th>Saldo pendiente</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map(it => (
                                <tr key={it.subscription_id}>
                                    <td className="font-semibold">{it.razon_social}</td>
                                    <td className="text-zinc-600 text-sm">{it.nombre_proyecto || "-"}</td>
                                    <td><CronogramaBadge cronograma={it.cronograma} /></td>
                                    <td className="font-mono">{COP(it.valor_contratado_cop)}</td>
                                    <td className="font-mono">{COP(it.total_pagado_cop)}</td>
                                    <td className="font-mono font-bold" style={{ color: it.saldo_pendiente_cop > 0 ? "#B45309" : "#16A34A" }}>
                                        {COP(it.saldo_pendiente_cop)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
